import React, { useEffect, useState } from 'react'
import 'react-date-range/dist/styles.css'
import 'react-date-range/dist/theme/default.css'
import ProcessController from "../components/process-controller"
import ImagesUploader from "../components/images-uploader"
import { handleImageUrl } from "../helpers";
import TextEditor from "../components/text-editor"
import FormControl from "@mui/material/FormControl";
import {Checkbox, FormControlLabel, FormGroup} from "@mui/material";
import Box from '@mui/material/Box';
import Tab from '@mui/material/Tab';
import TabContext from '@material-ui/lab/TabContext';
import TabList from '@material-ui/lab/TabList';
import TabPanel from '@material-ui/lab/TabPanel';
import {axios} from "../axios";
import {useNavigate, useParams} from "react-router-dom";

// Existing uploads keep their stored path (sent back as existing_*) apart from the display URL
const fileUrlsToUploaderData = (paths)=>{
    return (paths || []).filter(p => p && p !== 'none_images').map(path => ({
        path,
        url: handleImageUrl(path),
    }))
}

const EditArmenia = () => {
    const params = useParams()
    const navigate = useNavigate()
    const [formData,setFormData] = useState({
        title_en:'',
        title_de:'',
        description_en:'',
        description_de:'',
        key_words_en:'',
        key_words_de:'',
        text_en:'',
        text_de:'',
        images:[],
        thumbnail:[],
        main_page: false,
    })
    const [section, setSection] = React.useState('1');
    const [submitProcess,setSubmitProcess] = useState('none')
    const [errors,setErrors] = useState([])

    const handleChange = (name,value)=>{
        setFormData({...formData,[name]: value})
    }
    const [week, setWeek] = React.useState({
        "0": false,
        "1": false,
        "2": false,
        "3": false,
        "4": false,
        "5": false,
        "6": false,
    });
    const handleWeekDay = (event) => {
        setWeek({
            ...week,
            [event.target.name]: event.target.checked,
        });
    };
    const handleSection = (event, newValue) => { setSection(newValue) }

    useEffect(()=>{
        setSubmitProcess('load')
        const fetchBothLangs = async () => {
            try {
                const reqEn = axios.get(`en/armenia/${params.id}`).catch(() => axios.get(`/armenia/${params.id}?lang=en`))
                const reqDe = axios.get(`de/armenia/${params.id}`).catch(() => axios.get(`/armenia/${params.id}?lang=de`))
                const [resEn, resDe] = await Promise.all([reqEn, reqDe])
                const dEn = resEn?.data || {}
                const dDe = resDe?.data || {}

                setFormData(prev => ({
                    ...prev,
                    title_en: dEn.title_en || dEn.title || '',
                    title_de: dDe.title_de || dDe.title || '',
                    description_en: dEn.description_en ?? dEn.description ?? '',
                    description_de: dDe.description_de ?? dDe.description ?? '',
                    key_words_en: (dEn.key_words_en ?? dEn.keywords_en ?? dEn.key_words ?? dEn.keywords ?? ''),
                    key_words_de: (dDe.key_words_de ?? dDe.keywords_de ?? dDe.key_words ?? dDe.keywords ?? ''),
                    text_en: dEn.text_en ?? dEn.text ?? '',
                    text_de: dDe.text_de ?? dDe.text ?? '',
                    main_page: !!(dEn.main_page ?? dDe.main_page),
                }))

                const thumb = dEn.thumbnail ?? dDe.thumbnail
                if (thumb) {
                    const thumbArr = Array.isArray(thumb) ? thumb : String(thumb).split(',').filter(Boolean)
                    setFormData(f => ({...f, thumbnail: fileUrlsToUploaderData(thumbArr)}))
                }
                const imgs = dEn.images ?? dDe.images
                if (imgs) {
                    const imgsArr = Array.isArray(imgs) ? imgs : String(imgs).split(',').filter(Boolean)
                    setFormData(f => ({...f, images: fileUrlsToUploaderData(imgsArr)}))
                }

                // available weekdays from string like "1;2;3"
                const aw = dEn.available_weekdays ?? dDe.available_weekdays
                if (aw) {
                    const w = {"0":false,"1":false,"2":false,"3":false,"4":false,"5":false,"6":false}
                    String(aw).split(';').filter(Boolean).forEach(k=>{ if(w[k]!==undefined) w[k]=true })
                    setWeek(w)
                }

                setSubmitProcess('none')
            } catch (e) {
                setSubmitProcess('none')
            }
        }
        fetchBothLangs()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    },[params.id])

    const validateForm = ()=>{
        if(!(formData.title_en || '').trim()){
            setErrors(['title_en']);
            return false;
        }
        setErrors([]);
        return true;
    }

    const textLengthValidate = () => {
        let errorsList = []
        if(formData.title_en.length > 60){ errorsList.push('title_en') }
        if(formData.title_de.length > 60){ errorsList.push('title_de'); setSubmitProcess('text length error') }
        if(formData.description_en.length > 160){ errorsList.push('description_en'); setSubmitProcess('text length error') }
        if(formData.description_de.length > 160){ errorsList.push('description_de'); setSubmitProcess('text length error') }
        setErrors(errorsList)
        return errorsList.length === 0
    }

    const handleSubmit = ()=>{
        if(!validateForm()){ setSubmitProcess('error'); return false }
        if(!textLengthValidate()){ setSubmitProcess('error-text-length'); return false }
        setSubmitProcess('load')
        let fd = new FormData()
        fd.append('title_en',formData.title_en)
        fd.append('title_de',formData.title_de)
        fd.append('description_en',formData.description_en)
        fd.append('description_de',formData.description_de)
        fd.append('key_words_en',formData.key_words_en)
        fd.append('key_words_de',formData.key_words_de)
        fd.append('text_en',formData.text_en)
        fd.append('text_de',formData.text_de)
        // Managed sets: the API keeps existing_images[] that are still shown, adds the new
        // images[] and deletes only what was removed
        fd.append('images_managed', '1')
        const imageItems = formData.images || []
        imageItems.forEach(el => {
            if (el.file) fd.append('images[]', el.file)
            else if (el.path) fd.append('existing_images[]', el.path)
        })
        fd.append('thumbnail_managed', '1')
        const thumbItem = (formData.thumbnail || [])[0]
        if (thumbItem?.file) fd.append('thumbnail', thumbItem.file)
        else if (thumbItem?.path) fd.append('existing_thumbnail', thumbItem.path)
        fd.append('main_page',formData.main_page)
        axios.post(`/armenia/${params.id}`,fd)
            .then(res => {
                if(res.data === 'updated' || res.data?.message === 'updated'){
                    setSubmitProcess('updated')
                }else{
                    setSubmitProcess('error')
                }
            })
            .catch(()=> setSubmitProcess('error'))
    }

    const handleDelete = ()=>{
        // eslint-disable-next-line no-restricted-globals
        const c = confirm('Delete this post?')
        if(!c) return
        setSubmitProcess('load')
        axios.delete(`/armenia/${params.id}`)
            .then(res=>{
                if(res.data?.message === 'deleted' || res.status === 200){
                    alert('Deleted successfully')
                    navigate('/armenia')
                }else{
                    setSubmitProcess('error')
                }
            })
            .catch(()=> setSubmitProcess('error'))
    }

    return (
        <div className='main-container'>
            <ProcessController
                entity='Article'
                setSubmitProcess={setSubmitProcess}
                submitProcess={submitProcess}
                locationPath='/armenia'
                handleSubmit={handleSubmit}
            />
            <div className='container mt-3'>
                <div className='d-flex justify-content-end'>
                    <button className='btn btn-danger' onClick={handleDelete}>Delete</button>
                </div>
            </div>
            <TabContext  value={section}>
                <Box sx={{ borderBottom: 1, borderColor: 'black',backgroundColor:'#0a5f9d',color:"white" }}>
                    <TabList onChange={handleSection} aria-label="lab API tabs example" >
                        <Tab label="SEO" value="1" style={{color:'white'}}/>
                        <Tab label="Details" value="3" style={{color:'white'}}/>
                        <Tab label="Images" value="5" style={{color:'white'}}/>
                    </TabList>
                </Box>
                <div className="add-post mt-3 form">
                    <div className="container">
                        <TabPanel value="1" style={{height:'100%'}}>
                            <div className="row mb-3">
                                <div className="col-6">
                                    <div className={`input-container require ${errors.includes('title_en') ? 'error' : ''}`}>
                                        <h6 className='title-label'>Title *</h6>
                                        <input  value={formData.title_en} onChange={e => handleChange('title_en',e.target.value)} type="text" placeholder={'max length 60 letters'}/>
                                    </div>
                                </div>
                                <div className="col-6">
                                    <div className={`input-container require ${errors.includes('title_de') ? 'error' : ''}`}>
                                        <h6 className='title-label'>Title (German) *</h6>
                                        <input  value={formData.title_de} onChange={e => handleChange('title_de',e.target.value)} type="text" placeholder={'max length 60 letters'}/>
                                    </div>
                                </div>
                            </div>
                            <div className="row mb-3">
                                <div className={`col-6 require ${errors.includes('description_en') ? 'error' : ''}`}>
                                    <div className='text-editor'>
                                        <h6 className='title-label'>Description *</h6>
                                        <textarea rows='6' placeholder='max length 120 letters' onChange={ e => handleChange('description_en', e.target.value)} value={formData.description_en}></textarea>
                                    </div>
                                </div>
                                <div className={`col-6 require ${errors.includes('description_de') ? 'error' : ''}`}>
                                    <div className='text-editor'>
                                        <h6 className='title-label'>Description (German) *</h6>
                                        <textarea rows='6' placeholder='max length 120 letters' onChange={ e => handleChange('description_de', e.target.value)} value={formData.description_de}></textarea>
                                    </div>
                                </div>
                            </div>
                            <div className="row mb-3">
                                <div className="col-6">
                                    <div className={`input-container mb-3 ${errors.includes('key_words_en') ? 'error' : ''}`}>
                                        <h6 className='title-label'>Key Words</h6>
                                        <input value={formData.key_words_en} onChange={ e => handleChange('key_words_en', e.target.value) } type="text" placeholder={'max length 60 letters'}/>
                                    </div>
                                </div>
                                <div className="col-6">
                                    <div className={`input-container mb-3 ${errors.includes('key_words_de') ? 'error' : ''}`}>
                                        <h6 className='title-label'>Key Words (German)</h6>
                                        <input value={formData.key_words_de} onChange={ e => handleChange('key_words_de', e.target.value) } type="text" placeholder={'max length 60 letters'}/>
                                    </div>
                                </div>
                            </div>
                            <div className="row mb-3">
                                <div className="col-6">
                                    <div className={`input-container mb-3 require`}>
                                        <h6 className='title-label text-center'>Main Page</h6>
                                        <input type="checkbox" className='checkbox' checked={!!formData.main_page} onChange={e => handleChange('main_page',e.target.checked)}/>
                                    </div>
                                </div>
                            </div>
                            <div className="row mb-3">
                                <div className="col-12">
                                    <h6 className='title-label'>Available Weekdays</h6>
                                    <Box sx={{ display: 'flex' }}>
                                        <FormControl component="fieldset" variant="standard">
                                            <FormGroup>
                                                <div className="d-flex">
                                                    <div className="d-flex flex-column">
                                                        <FormControlLabel control={<Checkbox checked={week["1"]} onChange={handleWeekDay} name="1" />} label="Monday" />
                                                        <FormControlLabel control={<Checkbox checked={week["2"]} onChange={handleWeekDay} name="2" />} label="Tuesday" />
                                                        <FormControlLabel control={<Checkbox checked={week["3"]} onChange={handleWeekDay} name="3" />} label="Wednesday" />
                                                        <FormControlLabel control={<Checkbox checked={week["4"]} onChange={handleWeekDay} name="4" />} label="Thursday" />
                                                    </div>
                                                    <div className="d-flex flex-column">
                                                        <FormControlLabel control={<Checkbox checked={week["5"]} onChange={handleWeekDay} name="5" />} label="Friday" />
                                                        <FormControlLabel control={<Checkbox checked={week["6"]} onChange={handleWeekDay} name="6" />} label="Saturday" />
                                                        <FormControlLabel control={<Checkbox checked={week["0"]} onChange={handleWeekDay} name="0" />} label="Sunday" />
                                                    </div>
                                                </div>
                                            </FormGroup>
                                        </FormControl>
                                    </Box>
                                </div>
                            </div>
                        </TabPanel>
                        <TabPanel value="3" style={{height:'100%'}}>
                            <div className="row mb-3">
                                <div className={`col-6 require ${errors.includes('text_en') ? 'error' : ''}`}>
                                    <TextEditor value={formData.text_en} handleChange={handleChange} name='text_en' title='Text *'/>
                                </div>
                                <div className={`col-6 require ${errors.includes('text_de') ? 'error' : ''}`}>
                                    <TextEditor value={formData.text_de} handleChange={handleChange} name='text_de' title='Text (German) *'/>
                                </div>
                            </div>
                        </TabPanel>
                        <TabPanel value="5">
                            <div className="row mb-3">
                                <div className={`col-6`}>
                                    <ImagesUploader data={formData.thumbnail} handleImages={handleChange} name='thumbnail' title='Thumbnail' multiple={false}/>
                                </div>
                                <div className={`col-6`}>
                                    <ImagesUploader data={formData.images} handleImages={handleChange} name='images' title='Images' multiple={true}/>
                                </div>
                            </div>
                        </TabPanel>
                    </div>
                </div>
            </TabContext>
        </div>
    );
};

export default EditArmenia;
